import { useState } from 'react';
import { Heading } from '@simplywallst/ui-core/next';
import TickSolid from '@simplywallst/ui-core/icons/TickSolid';
import type { Brokerage } from '@/features/portfolio/components/PortfolioLinking/hooks/useBrokerSearch';
import { PopularBrokerage } from '@/features/portfolio/components/PortfolioLinking/components/PopularBrokerage';
import { CreateLinkedPortfolio } from '@/features/portfolio/components/PortfolioLinking';

export const NewLinkedPortfolio = () => {
  const [brokerage, setBrokerage] = useState<Brokerage | undefined>(undefined);

  return (
    <>
      <div
        className="grid gap-x1_5 px-x2 sm:px-x3"
        data-cy-id="portfolio-linking"
      >
        <div>
          <Heading as="h2">
            Create by linking your broker
            <span className="ml-x1 text-pretty rounded-md bg-surface-3 px-2 py-1 text-tiny font-normal text-soft">
              Automatic daily sync
            </span>
          </Heading>
        </div>
        <CreateLinkedPortfolio
          brokerage={brokerage}
          setBrokerage={setBrokerage}
        />
      </div>
      <PopularBrokerage onSelect={setBrokerage} />

      <div className="px-x2 sm:px-x3">
        <span className="mb-x0_5 mr-x1 py-1 text-tiny text-soft">
          Returns analysis
        </span>
        <span className="mb-x0_5 mr-x0_5 inline-grid grid-cols-[max-content_auto] items-center gap-x0_5 rounded-md bg-surface-3 px-2 py-1">
          <span className="text-pretty text-tiny text-solid">Unrealised</span>
          <TickSolid className="size-5 fill-p-green" />
        </span>
      </div>
    </>
  );
};
